import Base from '@/parts/pages/base';

// import Register from "@/parts/pages/register"
import Sign from '@/parts/pages/sign';
import Contract from '@/parts/pages/contract';

// import Dashboard from "@/parts/pages/vibbrant/index"
import Clients from '@/parts/pages/vibbrant/clients/clients';
import Client from '@/parts/pages/vibbrant/clients/client';
import Login from '@/parts/pages/loginProfessional';
import Register from '@/parts/pages/registerProfissional';
// import Profile from "@/parts/pages/vibbrant/profile"
import Wallet from '@/parts/pages/vibbrant/wallet';
import RecoverPass from '@/parts/pages/recover-pass';
import NewPass from '@/parts/pages/new-pass';
import AcceptVibbrant from '@/parts/pages/accept-vibbrant';
// import TutorialsVibbrant from "@/parts/pages/tutorials-vibbrant"

import Terms from '@/parts/pages/terms';
import Privacy from '@/parts/pages/privacy';

// import store from "@/store"

export default {
  path: '/vibbrant',
  component: Base,
  children: [
    {
      path: '',
      name: 'vibbrant-dashboard',
      component: Clients,
      props: { profile: 'vibbrant' },
      meta: { requireAuth: true },
    },
    {
      path: 'login',
      name: 'vibbrant-login',
      component: Login,
      props: { profile: 'vibbrant' },
      meta: { requireAuth: false },
    },
    {
      path: 'register',
      name: 'vibbrant-register',
      component: Register,
      props: { profile: 'vibbrant' },
      meta: { requireAuth: false },
    },
    // {
    //   path: 'loginProfessional',
    //   name: 'vibbrant-login',
    //   component: LoginProfessional,
    //   props: { profile: 'vibbrant' },
    //   meta: { requireAuth: false },
    // },
    // { path: 'register', name: 'vibbrant-register', component: Register, props: {profile: 'vibbrant'}, meta: {requireAuth: false} },
    {
      path: 'profile',
      name: 'vibbrant-profile',
      beforeEnter() {
        location.href = process.env.NEW_APP + '/recruitment/0/profile';
      },
      // component: Profile,
      // props: { profile: "vibbrant" },
      // meta: { requireAuth: true }
    },
    {
      path: 'wallet',
      name: 'vibbrant-wallet',
      component: Wallet,
      props: { profile: 'vibbrant' },
      meta: { requireAuth: true },
    },
    {
      path: 'clients',
      name: 'vibbrant-clients',
      component: Clients,
      props: { profile: 'vibbrant' },
      meta: { requireAuth: true },
    },
    {
      path: 'clients/active',
      name: 'vibbrant-clients-active',
      component: Clients,
      props: { profile: 'vibbrant', activeTab: 'active' },
      meta: { requireAuth: true },
    },
    {
      path: 'clients/pending',
      name: 'vibbrant-clients-pending',
      component: Clients,
      props: { profile: 'vibbrant', activeTab: 'pending' },
      meta: { requireAuth: true },
    },
    {
      path: 'clients/finalized',
      name: 'vibbrant-clients-finalized',
      component: Clients,
      props: { profile: 'vibbrant', activeTab: 'finalized' },
      meta: { requireAuth: true },
    },
    {
      path: 'clients/:name/:id',
      name: 'vibbrant-client',
      component: Client,
      props: { profile: 'vibbrant' },
      meta: { requireAuth: true },
    },
    {
      path: 'clients/:name/:id/:task',
      name: 'vibbrant-client-task',
      component: Client,
      props: { profile: 'vibbrant' },
      meta: { requireAuth: true },
    },
    {
      path: 'clients/contract/:id',
      name: 'vibbrant-contract',
      component: Contract,
      props: { profile: 'vibbrant' },
      meta: { requireAuth: true },
    },
    {
      path: 'sign/:id/:client_id',
      name: 'vibbrant-sign',
      component: Sign,
      props: { profile: 'vibbrant' },
      meta: { requireAuth: true },
    },
    {
      path: 'recover-pass',
      name: 'vibbrant-recover-pass',
      component: RecoverPass,
      props: { profile: 'vibbrant' },
      meta: { requireAuth: false },
    },
    {
      path: 'new-pass',
      name: 'vibbrant-new-pass',
      component: NewPass,
      props: { profile: 'vibbrant' },
      meta: { requireAuth: false },
    },
    {
      path: 'accept-vibbrant',
      name: 'accept-vibbrant',
      component: AcceptVibbrant,
      props: { profile: 'vibbrant' },
      meta: { requireAuth: true },
    },
    /* {
      path: "tutorials-vibbrant",
      name: "tutorials-vibbrant",
      component: TutorialsVibbrant,
      props: { profile: "vibbrant" },
      meta: { requireAuth: true }
    }, */
    {
      path: 'accept-vibbrant-show',
      name: 'accept-vibbrant-show',
      component: AcceptVibbrant,
      props: { profile: 'vibbrant', showAcceptButton: false },
      meta: { requireAuth: false },
    },
    {
      path: 'terms/:id',
      name: 'vibbrant-terms-signed',
      component: Terms,
      props: { profile: 'vibbrant' },
      meta: { requireAuth: true },
    },
    {
      path: 'privacy/:id',
      name: 'vibbrant-privacy-signed',
      component: Privacy,
      props: { profile: 'vibbrant' },
      meta: { requireAuth: true },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/vibbrant.js